﻿import { ApiCaller } from 'apis/ApiCaller';

export interface FeedbackCategory {
	Id: number;
	Name: string;
	SubCategory: FeedbackCategory[];
}

export class FeedbackApi {

    private static apiCaller = new ApiCaller('Feedback');

    // Array of categories to display in a dropdown for feedback.
    public static GetFeedbackCategories(cultureId = 0): Promise<FeedbackCategory[]> {

	    return this.apiCaller.GET<FeedbackCategory[]>('GetFeedbackCategories', { cultureId });

    }

    // Storing feedback from the user.
    public static SubmitFeedback(feedbackSubCategoryId: number, location: string, feedbackMessage: string): Promise<number> {

	    return this.apiCaller.POST<number>('SubmitFeedback', { feedbackMessage, feedbackSubCategoryId, location });

    }

}